const rows = [
  { feature: "Appointment Required", agency: "Yes — limited availability, often weeks out", fpc: "No appointment needed to start" },
  { feature: "In-Person Visit", agency: "Required — drive to Atlanta (~2.5 hours from Hoover)", fpc: "Most travelers ship documents overnight" },
  { feature: "Processing Speed", agency: "Urgent travel only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
  { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review to reduce delays" },
  { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability" },
  { feature: "Predictability", agency: "Appointments can be cancelled or unavailable", fpc: "Predictable processing based on option selected" },
  { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only", fpc: "Most U.S. citizens with required documents" },
  { feature: "Cost vs Resellers", agency: "Not applicable", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
  { feature: "Direct State Dept. Access", agency: "Not available to the public", fpc: "Registered courier — not a middleman or reseller" },
];

export default function HooverComparisonSection() {
  return (
    <section id="comparison" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="bg-[#FFF9E6] border border-[#F6C344]/20 rounded-lg p-6 mb-8">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-[#1A365D] text-sm"></i>
            </div>
            <div>
              <p className="text-sm text-[#1A365D] font-semibold mb-1">Passport Agency Appointment Not Available?</p>
              <p className="text-sm text-gray-600">The Atlanta Passport Agency requires a confirmed NPIC appointment — often booked weeks out. Skip the 2.5-hour drive. <a href="https://fastpassportcenter.com/checkout/" className="text-[#1A365D] font-semibold hover:underline whitespace-nowrap">Get Started <i className="ri-arrow-right-line"></i></a></p>
            </div>
          </div>
        </div>
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Emergency Passports</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Regional Passport Agency vs. Fast Passport Center
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            If you need your passport <strong className="text-[#1A365D]">within two weeks</strong>, the Atlanta Passport Agency (230 Peachtree Street NW, Suite 1000, Atlanta, GA 30303) is your only do-it-yourself option — about 2.5 hours from Hoover via I-20. Getting an appointment is rarely straightforward. Fast Passport Center gives you a faster, simpler path without taking a day off work.
          </p>
        </div>
        <div className="rounded-lg overflow-hidden border border-gray-200">
          <div className="grid grid-cols-3 bg-[#1A365D] text-white">
            <div className="p-4 text-sm font-semibold text-white/50">Feature</div>
            <div className="p-4 text-sm font-semibold text-center border-l border-white/10"><i className="ri-government-line mr-1.5"></i>Regional Passport Agency</div>
            <div className="p-4 text-sm font-semibold text-center border-l border-white/10 bg-[#F6C344]/15"><i className="ri-shield-check-line mr-1.5 text-[#F6C344]"></i>Fast Passport Center</div>
          </div>
          {rows.map((row, i) => (
            <div key={i} className={`grid grid-cols-3 border-t border-gray-100 ${i % 2 === 0 ? "bg-white" : "bg-[#F7F8FA]"}`}>
              <div className="p-4 text-sm font-semibold text-[#1A365D]">{row.feature}</div>
              <div className="p-4 text-sm text-gray-500 border-l border-gray-100 flex items-start gap-2">
                <i className="ri-close-circle-line text-red-400 flex-shrink-0 mt-0.5"></i><span>{row.agency}</span>
              </div>
              <div className="p-4 text-sm text-gray-700 border-l border-gray-100 flex items-start gap-2 bg-[#F6C344]/5">
                <i className="ri-checkbox-circle-line text-[#F6C344] flex-shrink-0 mt-0.5"></i><span className="font-medium">{row.fpc}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-8 text-center">
          <a href="https://fastpassportcenter.com/checkout/" className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap">
            Start My Expedited Passport <i className="ri-arrow-right-line"></i>
          </a>
          <p className="text-gray-400 text-xs mt-3">Atlanta Passport Agency — 230 Peachtree Street NW, Suite 1000, Atlanta, GA 30303 — About 2.5 hours from Hoover via I-20</p>
        </div>
      </div>
    </section>
  );
}